export let patientPrescriptionEn: Record<string, any> = {
    patient_prescription_list: 'Patient prescriptions list',
};
